import './App.css';
import { Component } from 'react';

import Home from './components/Home';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './components/Login';
import VoiceJourney from './components/VoiceJourney';
// import Consent from './components/Consent';
import { Route, Switch } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { postMessage } from './utils/common.utils';
import Error from './components/Error';
import ConsentStatus from './components/ConsentStatus';
import Header from './components/common/Header';
import AccountDiscovery from './components/AccountDiscovery';
import AddNumber from './components/AddNumber';
import Toast from './components/Toast/ToastContainer';
import PaymentConsent from './components/PaymentConsent';
import { ConsentContext } from './components/Context/ConsentContext';
import { StepperProvider } from './components/Context/StepperContext';
import { registerEvent } from './utils/tracking.utils';
import AuthApis from './hepler/authApis.service';
import Loader from './components/Loader/Loader';
import NoAccountFoundExit from './components/NoAccountFoundExit';
import ConsentRenew from './components/ConsentRenew/ConsentRenew';
import ConsentRenewStatus from './components/ConsentRenew/ConsentRenewStatus';
import { store } from './store';
import { loadTranslations } from './store/translationSlice';
import { UserActionProvider } from './components/Context/UserActionContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import PreLogin from './components/Mfa/PreLogin';
import TwoFaChoice from './components/Mfa/TwoFaChoice';
import FaqDrawer from './components/Sections/FaqDrawer';
import { is2FAEnabled } from './utils/entityConfig.utils';
const defaultConfig = {
	fontFamily: 'Lato',
	primaryColor: '#017aff',
	secondaryColor: '#F5F5F5',
	headingColor: '#191c1f',
	subHeadingColor: '#0e65d7',
	textColor: '#757779',
	btnHeight: '48px',
	btnWidth: '327px',
	borderRadius: '40px',
};
class App extends Component {
	constructor(props) {
		super(props);
		const queryParams = new URLSearchParams(window.location.search);
		this.disableEvents = queryParams.get('disableEvents');
		this.protocol = queryParams.get('protocol');
		this.authApis = new AuthApis()
		registerEvent({
			'LINKED_ACCOUNTS_DISCOVERED': {
				category: 'discovery',
				fipId: '',
				count: 0,
			},
			'UNLINKED_ACCOUNTS_DISCOVERED': {
				category: 'discovery',
				fipId: '',
				count: 0,
			},
			'MULTIPLE_FIP_LINKING': {
				category: 'linking',
				stage: 'LINKING_OTP_INCORRECT,LINKING_FAILURE,LINKING_SUCCESS',
				count: 0,
				totalFips:0
			},
			'MULTIPLE_FIP_DISCOVERY': {
				category: 'discovery',
				stage: 'DISCOVERY_FAILED,ACCOUNTS_NOT_DISCOVERED,ACCOUNTS_DISCOVERED',
				count: 0,
				totalFips:0
			},
		});
		this.ecreq = queryParams.get('ecreq');
		this.reqdate = queryParams.get('reqdate');
		this.fi = queryParams.get('fi') ? queryParams.get('fi') : '';
		this.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.isAddAccount = queryParams.get('isAddAccount') ? true : false;
		global.mobileNumberArray = [];
		this.state = {
			isLoader: false,
			initialLoader: false,
			configDetails: defaultConfig,
			timerStart: false,
			sdkReady: false,
			loginStageStatus: { isLoading: false, loadingText: "", isSuccess: false, successText: "", mobileNumber: "" },
			isTextExiting: false,
		};
		this.timerId = null;
		this.textChangeTimer = null;
		this.mainEl = null;
	}
	async componentDidMount() {
		await window.finvuClient.openV2("", "" ,{dEvents:this.disableEvents ?? null,protocol:this.protocol ?? null});
		this.setState({ sdkReady: true });
		store.dispatch(loadTranslations('en'));
		if (!this.ecreq || !this.fi || !this.reqdate) {
			postMessage('session', 'FAILURE');
		}
	}	
	componentDidUpdate(prevProps, prevState) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			if (this.props.history.action === 'POP') {
				window.confirm(
					'Are you sure to go back ? Consent will not be actioned.'
				);
			}
		}
		if (this.state.timerStart && !prevState.timerStart) {
			this.timerId = setTimeout(() => {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						statusCode: this.authApis.handleCancelTermination(),
					},
				});
			}, process.env.REACT_APP_SESSION_TIMEOUT_TIME);
		}
		if (
			prevState.isLoader !== this.state.isLoader ||
			prevState.loginStageStatus !== this.state.loginStageStatus
		) {
			this.syncMainInert();
		}
	}
	componentWillUnmount() {
		if (this.timerId) {
			clearTimeout(this.timerId);
		}
		if (this.textChangeTimer) {
			clearTimeout(this.textChangeTimer);
		}
		if (this.props.history.action === 'POP') {
			window.confirm('Are u sure u want to mountmount');
		}
	}

	toggleTimer = () => {
		this.setState({ timerStart: true });
	};

	updateLoader = (val) => {
		this.setState({ isLoader: val });
	};
	syncMainInert = () => {
		if (!this.mainEl) {
			return;
		}
		const blockInteraction =
			this.state.isLoader ||
			this.state.loginStageStatus?.isLoading ||
			this.state.loginStageStatus?.isSuccess;
		if (blockInteraction) {
			this.mainEl.setAttribute('inert', '');
		} else {
			this.mainEl.removeAttribute('inert');
		}
	};
	updateInitialLoader = (val) => {
		this.setState({ initialLoader: val });
	};
	updateEntityID = (data) => {
		this.setState({ configDetails: data });
	};
	updateLoginStageLoader = (loginLoaderData) => {
		const newText = loginLoaderData?.isSuccess 
			? (loginLoaderData?.successText ?? "Verification successful")
			: (loginLoaderData?.loadingText ?? "");
		const currentText = this.state.loginStageStatus?.isLoading 
			? this.state.loginStageStatus?.loadingText 
			: this.state.loginStageStatus?.successText;
		
		// If text is changing, trigger exit animation first
		if (currentText && newText && currentText !== newText) {
			this.setState({ isTextExiting: true });
			
			if (this.textChangeTimer) clearTimeout(this.textChangeTimer);
			this.textChangeTimer = setTimeout(() => {
				requestAnimationFrame(() => {
					this.setState({
						loginStageStatus:{
							isLoading:loginLoaderData?.isLoading ?? false, 
							loadingText:loginLoaderData?.loadingText ?? "", 
							isSuccess:loginLoaderData?.isSuccess ?? false, 
							successText:loginLoaderData?.successText ?? "", 
							mobileNumber:loginLoaderData?.mobileNumber ?? ""
						},
						isTextExiting: false
					});
				});
			}, 300);
		} else {
			requestAnimationFrame(() => {
				this.setState({
					loginStageStatus:{
						isLoading:loginLoaderData?.isLoading ?? false, 
						loadingText:loginLoaderData?.loadingText ?? "", 
						isSuccess:loginLoaderData?.isSuccess ?? false, 
						successText:loginLoaderData?.successText ?? "", 
						mobileNumber:loginLoaderData?.mobileNumber ?? ""
					}
				});
			});
		}
		
		if(loginLoaderData?.isSuccess == true){
			setTimeout(() => {
				this.updateLoginStageLoader({isSuccess:false})
			},1000)
		}
	}

	render() {
		return (
			<ConsentContext>
				<StepperProvider>
					<UserActionProvider>
				<div
					className="App"
					style={{ 
						fontFamily: this.state.configDetails?.fontFamily,
						backgroundColor: this.state.configDetails?.darkTheme ? '#161616' : 'transparent',
						color: this.state.configDetails?.darkTheme ? '#FFFFFF' : '#000000',
						minHeight: '100vh'
					}}
				>
					<Header  customDetails={this.state.configDetails} />
					<main
						id="main-content"
						tabIndex={-1}
						ref={(el) => {
							this.mainEl = el;
							this.syncMainInert();
						}}
					>
					{this.ecreq && this.fi && this.reqdate ? (
						
						<Switch>
							<Route
								exact
								path="/"
								render={(props) =>
									is2FAEnabled(this.state.configDetails) ? (
										<PreLogin
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											toggleTimer={this.toggleTimer}
											sdkReady={this.state.sdkReady}
											updateLoginStageLoader={this.updateLoginStageLoader}
										/>
									) : (
										<Login
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											toggleTimer={this.toggleTimer}
											sdkReady={this.state.sdkReady}
											updateLoginStageLoader={this.updateLoginStageLoader}
										/>
									)
								}
							/>
							<Route
								exact
								path="/mfa-choice"
								render={(props) => (
									<>
										<TwoFaChoice
											{...props}
											customDetails={this.state.configDetails}
											sdkReady={this.state.sdkReady}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/login"
								render={(props) => (
									<>
										<Login
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											toggleTimer={this.toggleTimer}
											sdkReady={this.state.sdkReady}
											updateLoginStageLoader={this.updateLoginStageLoader}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/home"
								render={(props) => (
									<>
										<Home
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/voice-journey"
								render={(props) => (
									<>
										<VoiceJourney
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/login/:fid?"
								render={(props) => (
									<>
										<Login
											updateEntityID={this.updateEntityID}
											updateInitialLoader={this.updateInitialLoader}
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											sdkReady={this.state.sdkReady}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/accounts/:number/:fid?"
								render={(props) => (
									<>
										<AccountDiscovery
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											updateInitialLoader={this.updateInitialLoader}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/payment-consent"
								render={(props) => (
									<>
										<PaymentConsent
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
											updateInitialLoader={this.updateInitialLoader}

										/>
									</>
								)}
							/>
							<Route
								exact
								path="/NoAccountFound/:number"
								render={(props) => (
									<>
										<AddNumber
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/exit"
								render={(props) => (
									<>
										<NoAccountFoundExit
											updateLoader={this.updateLoader}
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/error"
								render={(props) => (
									<>
										<Error
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
							<Route
								exact
								path="/consent-status"
								render={(props) => (
									<>
										<ConsentStatus
											{...props}
											customDetails={this.state.configDetails}
										/>
									</>
								)}
							/>
						<Route
							exact
							path="/consent-renew"
							render={(props) => (
								<>
									<ConsentRenew
										{...props}
										customDetails={this.state.configDetails}
									/>
								</>
							)}
						/>
						<Route
							exact
							path="/consent-renew-status"
							render={(props) => (
								<>
									<ConsentRenewStatus
										{...props}
										customDetails={this.state.configDetails}
									/>
								</>
							)}
						/>
					</Switch>
					) : (
						<div className="centervs px-2">
							<h1 style={{ fontFamily: this.state.configDetails?.fontFamily }}>
								Oops!
							</h1>
							<h2 style={{ fontFamily: this.state.configDetails?.fontFamily }}>
								404 Not Found
							</h2>
							<div
								className="error-details"
								style={{ fontFamily: this.state.configDetails?.fontFamily }}
							>
								Sorry, an error has occured, Requested page not found!
							</div>
						</div>
					)}

					</main>

					{/* To display Success, Warning or Error messages to user */}
					<div className="toast-message" role="region" aria-label="Notifications">
						<Toast />
					</div>
					{/* To display API call Loader */}
					{this.state.isLoader ? (
						<div>
							<div
								className="application-loading-container"
								role="status"
								aria-live="polite"
								aria-busy="true"
								aria-label="Loading"
							>
								<div className="snippet" data-title=".dot-pulse">
									<div className="stage">
										<div className="dot-pulse-btn"></div>
									</div>
								</div>
								{/* <img className="image" src={LoaderImage} alt="" width="120" height="120"></img> */}
							</div>
						</div>
					) : null}
					{/* To display Initial Loader */}
					{this.state.initialLoader ? (
						<Loader/>
					) : null}
{(this.state.loginStageStatus?.isLoading || this.state.loginStageStatus?.isSuccess) && (
					<Box
						role="status"
						aria-live="polite"
						aria-busy={this.state.loginStageStatus?.isLoading ? true : undefined}
						sx={{
						height: "100vh",
						width: "100vw",
						position: "fixed",
						top: "0",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						background: this.state.configDetails?.darkTheme ? 'rgba(22, 22, 22, 0.98)' : 'rgba(255, 255, 255, 0.98)',
						backdropFilter: "blur(4px)",
						zIndex: "999999",
						flexDirection: "column",
						"@keyframes textFadeIn": {
							"0%": { opacity: 0, transform: "translateY(10px)" },
							"100%": { opacity: 1, transform: "translateY(0)" }
						},
						"@keyframes textSlideUpOut": {
							"0%": { opacity: 1, transform: "translateY(0)" },
							"100%": { opacity: 0, transform: "translateY(-10px)" }
						},
						"@keyframes fastRotate": {
							'0%': { transform: 'rotate(0deg)' },
							'100%': { transform: 'rotate(360deg)' }
						},
						"@keyframes fastDash": {
							'0%': { strokeDasharray: '1px, 200px', strokeDashoffset: '0px' },
							'50%': { strokeDasharray: '100px, 200px', strokeDashoffset: '-15px' },
							'100%': { strokeDasharray: '100px, 200px', strokeDashoffset: '-125px' }
						},
						"@keyframes drawCheck": {
							to: { strokeDashoffset: 0 }
						}
					}}>
						<Box sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							width: "100%",
							maxWidth: "400px"
						}}>
							{this.state.loginStageStatus.isLoading ? (
								<CircularProgress 
									size={"6rem"} 
									sx={{ 
										color: this.state.configDetails?.primaryColor,
										'& .MuiCircularProgress-svg': {
											animation: 'fastRotate 0.8s linear infinite'
										},
										'& .MuiCircularProgress-circle': {
											strokeDasharray: '80px, 200px',
											strokeDashoffset: '0px',
											animation: 'fastDash 1.2s ease-in-out infinite'
										}
									}} 
								/>
							) : (
								<Box sx={{
									width: "6rem",
									height: "6rem",
									minWidth: "6rem",
									minHeight: "6rem",
									borderRadius: "50%",
									backgroundColor: this.state.configDetails?.primaryColor ?? "#017aff",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									flexShrink: 0
								}}>
									<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
										<path 
											d="M15 30L25 40L45 20" 
											stroke="white" 
											strokeWidth="4" 
											strokeLinecap="round" 
											strokeLinejoin="round"
											style={{
												strokeDasharray: 60,
												strokeDashoffset: 60,
												animation: "drawCheck 0.5s ease-out forwards"
											}}
										/>
									</svg>
								</Box>
							)}
							<Box sx={{ 
								position: "relative", 
								marginTop: "1rem",
								overflow: "visible",
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "0.5rem",
								minHeight: "3.5rem"
							}}>
								<Typography 
									sx={{
										fontSize:"1.2rem", 
										color: this.state.configDetails?.darkTheme ? '#E0E0E0' : '#616161',
										animation: this.state.isTextExiting ? "textSlideUpOut 0.2s ease-out both" : "textFadeIn 0.2s ease-out both",
										textAlign: "center",
										whiteSpace: "nowrap"
									}}
								>
									{this.state.loginStageStatus.isLoading 
										? this.state.loginStageStatus?.loadingText ?? "" 
										: this.state.loginStageStatus?.successText ?? "Verification successful"}
								</Typography>
								{this.state.loginStageStatus?.mobileNumber && (
									<Typography 
										sx={{
											fontSize:"1rem", 
											color: this.state.configDetails?.darkTheme ? '#FFFFFF' : '#000000',
											textAlign: "center",
											fontWeight: 500
										}}
									>
										{this.state.loginStageStatus.mobileNumber}
									</Typography>
								)}
							</Box>
						</Box>
					</Box>
				)}

			</div>
				<FaqDrawer customDetails={this.state.configDetails} />
				</UserActionProvider>
			</StepperProvider>
		</ConsentContext>
		);
	}
}

export default App;
